import React, { PureComponent } from "react";
import { ActivityIndicator, View } from "react-native";
import { connect } from "react-redux";
import PassbookView from "./View";

import colors from "@constants/color";
import { styles } from "./styles";
import { actions as orderActions } from "@reducers/orderReducer";
import { getPassbookTransactions } from "../../services/api";
import { format } from "date-fns";

const statusMap = {
  pending: "पेंडिंग",
  processing: "प्रोसेसिंग",
  processed: "सक्सेसफुल",
  errored: "फेल्ड",
  cancelled: "कैंसिल",
};

class Passbook extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      passbookItems: [],
      isPassbookDataFetching: false,
      passbookData: null,
    };
    this.limit = 100;
    this.offset = 0;
  }

  componentDidMount() {
    this.fetchTransactions(true);
  }

  getFormatedDate = (date) => {
    return format(new Date(date), "yyyy-MM-dd");
  };

  fetchTransactions = (
    firstCall = false,
    dateRange = null,
    shouldFetchDirectlyByDate = false,
  ) => {
    const { passbookData, isPassbookDataFetching } = this.state;

    if (
      !firstCall &&
      passbookData &&
      passbookData.data &&
      passbookData.data.length >= Number(passbookData.count)
    ) {
      return;
    }

    if (!isPassbookDataFetching) {
      this.setState({
        isPassbookDataFetching: true,
      });
    }

    const { toDate, fromDate } = this.props.currentFilter;

    let dates = {
      to: this.getFormatedDate(toDate),
      from: this.getFormatedDate(fromDate),
    };

    if (shouldFetchDirectlyByDate) {
      dates = {
        to: this.getFormatedDate(dateRange.to),
        from: this.getFormatedDate(dateRange.from),
      };
    }

    if (!firstCall) {
      this.offset += 100;
    }

    getPassbookTransactions({
      ...dates,
      limit: this.limit,
      offset: this.offset,
      wt_ids: this.props?.route?.params?.wt_ids,
    })
      .then(({ data }) => {
        let fullData = data;
        // console.log(fullData);

        if (!firstCall) {
          fullData = {
            ...this.state.passbookData,
            data: [...this.state.passbookData.data, ...data.data],
          };
        }

        this.setState({
          passbookData: fullData,
          isPassbookDataFetching: false,
          passbookItems: this.manipulatedPassbookItems(fullData.data),
        });
      })
      .catch((e) => {
        console.log(e);
      });
  };

  onPressOrder = (orderData) => {
    this.props.dispatch(
      orderActions.setSelectedOrder(parseInt(orderData.orderNumber, 10)),
    );
    if (
      this.props.navigation &&
      typeof this.props.navigation.navigate === "function"
    ) {
      this.props.navigation.navigate("OrderDetails");
    }
  };

  isCloseToBottom = ({ layoutMeasurement, contentOffset, contentSize }) => {
    return layoutMeasurement.height + contentOffset.y >= contentSize.height;
  };

  onScrollCustomerList = (e) => {
    if (!this.state.isPassbookDataFetching) {
      this.fetchTransactions(false);
    }
  };

  manipulatedPassbookItems = (data) => {
    return data.map((passbookItem) => {
      let itemProps = {};
      if (passbookItem.type === "commission-credit") {
        itemProps = {
          typeHi: passbookItem.typeHi,
          id: passbookItem.type,
          type: passbookItem.type,
          orderCommissionView: true,
          orderCommissionData: {
            title: passbookItem.reason || "",
            username: passbookItem.customer_name,
            orderNumber: passbookItem.order_id,
            date: passbookItem.date,
            // status: passbookItem.statusHi,
            status: statusMap[passbookItem.status],
            statusKey: passbookItem.status,
            isDeliveredByCMO: passbookItem.is_delivered_by_cmo,
          },
          secondaryStats: true,
          secondaryStatsData: Array.isArray(passbookItem.data)
            ? passbookItem.data.map((s) => ({
                title: s.label,
                value: s.value !== null ? `₹${s.value}` : "",
              }))
            : [],
        };
      } else if (
        passbookItem.type !== "commission-credit" &&
        passbookItem.type !== "withdrawal"
      ) {
        itemProps = {
          typeHi: passbookItem.typeHi,
          id: passbookItem.type,
          type: passbookItem.type,
          otherCommissionsView: true,
          otherCommissionsData: {
            title: passbookItem.reason,
            commission: passbookItem.amount,
            date: passbookItem.date,
            // status: passbookItem.statusHi,
            status: statusMap[passbookItem.status],
            statusKey: passbookItem.status,
          },
        };
      } else if (passbookItem.type === "withdrawal") {
        itemProps = {
          typeHi: passbookItem.typeHi,
          id: passbookItem.type,
          type: passbookItem.type,
          title: passbookItem.reason,
          value: passbookItem.amount,
          date: passbookItem.date,
          // status: passbookItem.statusHi,
          status: statusMap[passbookItem.status],
          statusKey: passbookItem.status,
        };
      }
      return itemProps;
    });
  };

  handleApplyFilter = ({ to, from }) => {
    this.offset = 0;

    this.fetchTransactions(true, { to, from }, true);
  };

  render() {
    const { isPassbookDataFetching = false, passbookItems } = this.state || {};

    const viewProps = {
      passbookData: passbookItems,
      onPressOrder: this.onPressOrder,
      handleApplyFilter: this.handleApplyFilter,
      onScrollCustomerList: this.onScrollCustomerList,
      navigation: this.props.navigation,
    };

    if (passbookItems.length === 0 && isPassbookDataFetching) {
      return (
        <View style={styles.loaderContainer}>
          <ActivityIndicator color={colors.primary} size="large" />
        </View>
      );
    }

    return <PassbookView {...viewProps} />;
  }
}

function mapStateToProps({ wallet: { currentFilter } }) {
  return {
    currentFilter,
  };
}

export default connect(mapStateToProps)(Passbook);
